import { render, staticRenderFns } from "./BotaoRelatorioExportacao.vue?vue&type=template&id=0dc3dcca&lang=pug"
import script from "./BotaoRelatorioExportacao.vue?vue&type=script&lang=js"
export * from "./BotaoRelatorioExportacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports